/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_All_ButtonInputs */



/**
* | output |
* | --- |
* | "Fix All" |
*
* @param {Qc_Fix_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_all_button = /** @type {((inputs?: Qc_Fix_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout corriger")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправить все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部修复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir tudo")
	return /** @type {LocalizedString} */ ("Fix All")
});